import React, { useState, useEffect } from 'react';
import { Input, Form, Radio, Message } from '@b-design/fusion';
import Button from '@/components/Button';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import Uploader from '@/components/Uploader';
// import DefaultIcon from '@/components/DefaultIcon';
import DefaultLogo from '@/assets/app-logo.png';
import { getQueryStringArgs } from '@/utils/url-parse';
import store from '@/store';
import { FormSubmit, promisifyValidate } from '@/components/Button';

import { Field } from '@alifd/next';

interface VersionDescription {
  // 应用名称
  name: string;
  // 应用id
  appId: string;
  // 应用logo地址
  iconPublicUrl: string;
  // 应用标语
  slogan: string;
  // 应用描述
  description: string;
  // 联系邮箱
  customerEmail: string;
  // 联系电话
  customerPhone: string;
  // 是否继承（标识,用于调用不同接口）
  inherit: boolean;
}
interface App {
  // app信息框架
  framework: string;
}
interface VersionDetail {
  // 应用id
  appId: string;
  // 应用渠道id
  channelCode: string;
  // 版本描述
  versionDescription: VersionDescription;
  // app描述
  app: App;
}
interface Props {
  // 抽屉表单显隐回调
  setVisible: (v: boolean) => void;
  // 下一步
  setCurSteps: (v: number) => void;
  // 版本信息详情
  versionDetail: VersionDetail;
}

const Confirm: React.FC<Props> = ({ setVisible, setCurSteps, versionDetail }) => {
  const { app, appId, channelCode } = versionDetail;
  const field = Field.useField();
  const { init, getValue, setValue, getError } = field;
  const { framework } = app;
  const [appType, setAppType] = useState('WindVane');
  const [icon, setIcon] = useState<any>({ publicUrl: '', relativePath: '' });
  const [dataSoruce, setDataSoruce] = useState<any>({});
  const [siteSettingsState] = store.useModel('siteSettings');
  const [spaceRoleState] = store.useModel('spaceRole');
  const { spaceId } = getQueryStringArgs();

  useEffect(() => {
    Requests.get('/rest/intercnn/app/publish/query', {
      appId,
      channelCode,
    }).then((res) => {
      if (res) {
        setDataSoruce(res?.list[0]);
      }
    });
  }, []);

  useEffect(() => {
    setAppType(framework);
    setValue('party', dataSoruce?.description?.party);
    setValue('appName', dataSoruce?.description?.name);
    setValue('slogan', dataSoruce?.description?.slogan);
    setValue('description', dataSoruce?.description?.description);
    setValue('email', dataSoruce?.description?.customerEmail);
    setValue('phonePrev', dataSoruce?.description?.customerPhone.split('-')[0]);
    setValue('phone', dataSoruce?.description?.customerPhone.split('-')[1]);
    setIcon({
      publicUrl: dataSoruce?.description?.iconPublicUrl,
      relativePath: dataSoruce?.description?.icon,
    });
  }, [dataSoruce]);

  // 提交表单
  const submitForm = async () => {
    const [errs, vals] = await promisifyValidate(field);
    if (errs) {
      return;
    }
    const params = {
      customerEmail: getValue('email'),
      name: getValue('appName'),
      slogan: getValue('slogan'),
      description: getValue('description'),
      customerPhone: getValue('phonePrev') + '-' + getValue('phone'),
      ...(spaceRoleState.roleList?.includes('ADMIN') &&
        spaceRoleState.type === 'CONSUMER' && { party: getValue('party') }),
      ...(icon?.relativePath && icon?.relativePath !== ''
        ? { icon: icon?.relativePath }
        : { icon: '' }),
      ...(icon?.publicUrl && icon?.publicUrl !== ''
        ? { iconPublicUrl: icon?.publicUrl }
        : { iconPublicUrl: '' }),
    };

    if (dataSoruce?.description?.inherit) {
      const res = await Requests.post('/rest/intercnn/app/update', {
        appId,
        // framework: appType,
        description: { ...params },
      })
      if (res) {
        setCurSteps(1);
      }
    } else {
      const res = await  Requests.post('/rest/intercnn/app/publish/update', {
        appId,
        channelCode,
        appDescription: { ...params },
      });
     if (res) {
        setCurSteps(1);
      }
    }
  };

  return (
    <div className="create-drawer-container">
      <div className="create-drawer-content">
        <Form className="confirm-form">
          <Form.Item
            name="appName"
            label={$i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name',
              dm: '应用名称',
            })}
            required
            disabled
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name.placeholder',
                dm: '请输入唯一的名称，长度为2~36个字符',
              })}
              style={{ width: '470px' }}
              {...init('appName', {
                initValue: '',
                rules: {
                  required: true,
                  minLength: 2,
                  maxLength: 36,
                  message: $i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.name.msg',
                    dm: '请输入正确的应用名称',
                  }),
                },
              })}
            />
            <p style={{ fontSize: 12, color: '#c82727' }}>{getError('appName')}</p>
          </Form.Item>
          {/* {spaceRoleState.role === 'ADMIN' && spaceRoleState.type === 'CONSUMER' && (
            <Form.Item
              name="party"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.create.drawer.belongTo',
                dm: '归属',
              })}
              required
            >
              <Radio.Group
                shape="button"
                data-shape="container"
                disabled
                {...init('party')}
              >
                <Radio id="PRIVILEGE" value="PRIVILEGE" data-ctype="icon-text">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.create.drawer.oneSideMiniapp',
                    dm: '一方小程序',
                  })}
                </Radio>
                <Radio id="THIRD" value="THIRD" data-ctype="icon-text">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.create.drawer.tripartiteMiniApp',
                    dm: '三方小程序',
                  })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          )} */}

          <Form.Item
            name="appType"
            label={$i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Type', dm: '类型' })}
            required
          >
            <Radio.Group
              // shape="button"
              data-shape="container"
              defaultValue={framework}
              disabled
            >
              <Radio
                id="Windvane"
                value="WindVane"
                // data-ctype="icon-text"
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Type.Windvane',
                  dm: 'Windvane',
                })}
              </Radio>
              <Radio
                id="Uniapp"
                value="UniApp"
                // data-ctype="icon-text"
              >
                {$i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Type.Uniapp', dm: 'Uniapp' })}
              </Radio>
            </Radio.Group>
            {appType === 'UniApp' ? (
              <div className="form-radio-uniapp-tip">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Type.Uniapp.tip',
                  dm: '不要使用下载的IDE，直接使用HBuilder',
                })}
              </div>
            ) : null}
          </Form.Item>
          <Form.Item
            name="slogan"
            label={$i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Slogan',
              dm: '口号',
            })}
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name.placeholder',
                dm: '请输入唯一的名称，长度为2~36个字符',
              })}
              style={{ width: '470px' }}
              {...init('slogan', {
                initValue: '',
                rules: {
                  minLength: 2,
                  maxLength: 36,
                  message: $i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.slogan.msg',
                    dm: '请输入正确的口号',
                  }),
                },
              })}
            />
            <p style={{ fontSize: 12, color: '#c82727' }}>{getError('slogan')}</p>
          </Form.Item>
          <Form.Item
            name="description"
            label={$i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Description', dm: '描述' })}
          >
            <Input.TextArea
              placeholder={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Description.placeholder',
                dm: '输入2-400个字符的描述',
              })}
              autoHeight={{ minRows: 4, maxRows: 8 }}
              style={{ width: '470px' }}
              {...init('description', {
                initValue: '',
                rules: {
                  minLength: 2,
                  maxLength: 400,
                  message: $i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.description.msg',
                    dm: '请输入正确的描述',
                  }),
                },
              })}
            />
            <p style={{ fontSize: 12, color: '#c82727' }}>{getError('description')}</p>
          </Form.Item>
          <Form.Item
            name="logo"
            label={$i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Logo', dm: '图标' })}
            className="logo"
          >
            {/* {icon?.publicUrl && icon?.publicUrl !== '' ? ( */}
            <Uploader.Image
              action="/rest/intercnn/app/uploadIcon"
              accept={['image/png', 'image/jpg', 'image/jpeg']}
              data={{ spaceId: spaceId, appId: appId }}
              maxSize={1024 * 1024}
              key={icon?.relativePath}
              {...init('logo', {})}
              value={
                icon?.relativePath
                  ? [
                      {
                        uid: '0',
                        state: 'done',
                        url: icon?.publicUrl,
                        downloadURL: icon?.publicUrl,
                        imgURL: icon?.publicUrl,
                        relativePath: icon?.relativePath,
                        publicUrl: icon?.publicUrl,
                      },
                    ]
                  : []
              }
              onCheckFail={(err, response, e) => {
                Message.warning({ title: response.msg });
              }}
              onError={() => {
                Message.error({
                  title: $i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.icon.Upload.failure',
                    dm: '上传失败',
                  }),
                });
              }}
              changeValue={setIcon}
              defaultImg={
                siteSettingsState?.miniappDefaultIcon
                  ? siteSettingsState?.miniappDefaultIcon
                  : DefaultLogo
              }
              version={true}
            />
            {/* ) : (
              <DefaultIcon
                defaultImg={
                  siteSettingsState?.miniappDefaultIcon
                    ? siteSettingsState?.miniappDefaultIcon
                    : DefaultLogo
                }
                changeValue={setIcon}
                version={true}
              />
            )} */}
            <div className="upload-format">
              {$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.upload.img.format1',
                dm: '文件类型:',
              })}
              <span>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format1.content',
                  dm: '.png / .jpg / .jpeg',
                })}
              </span>
              <br />
              {$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.upload.img.format2',
                dm: '规格:',
              })}
              <span>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format2.content',
                  dm: '180px * 180px',
                })}
              </span>
              <br />
              {$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.upload.img.format3',
                dm: '最大大小:',
              })}
              <span>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format3.content',
                  dm: '1M',
                })}
              </span>
              <br />
              {$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.upload.img.format4',
                dm: '背景:',
              })}
              <span>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format4.content',
                  dm: '不透明',
                })}
              </span>
            </div>
          </Form.Item>
          <Form.Item
            name="phone"
            label={$i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Number',
              dm: '客服电话',
            })}
          >
            <Input
              placeholder="60"
              style={{ width: '100px' }}
              {...init('phonePrev', {
                initValue: '',
                rules: [
                  {
                    pattern: /^[\d]{1,4}$/,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                      dm: '请输入正确的手机号',
                    }),
                  },
                ],
              })}
            />
            <span style={{ display: 'inline-block', margin: '0 5px' }}>-</span>
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Number.placeholder',
                dm: '填写电话',
              })}
              style={{ width: 355 }}
              {...init('phone', {
                initValue: '',
                rules: [
                  {
                    pattern: /^[\d]{1,11}$/,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                      dm: '请输入正确的手机号',
                    }),
                  },
                ],
              })}
            />
            {getError('phone') || getError('phonePrev') ? (
              <p style={{ fontSize: 12, color: '#c82727' }}>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                  dm: '请输入正确的手机号',
                })}
              </p>
            ) : null}
          </Form.Item>
          <Form.Item
            name="email"
            label={$i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Email',
              dm: '客服邮箱',
            })}
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Email.placeholder',
                dm: 'example@email.com',
              })}
              style={{ width: '470px' }}
              {...init('email', {
                initValue: '',
                rules: [
                  {
                    pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,}$/,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.email.msg',
                      dm: '请输入正确的邮箱',
                    }),
                  },
                ],
              })}
            />
            <p style={{ fontSize: 12, color: '#c82727' }}>{getError('email')}</p>
          </Form.Item>
          <Form.Item name="agree" className="nextBtn">
            <FormSubmit
              type="primary"
              onClick={submitForm}
              validate
              style={{
                height: 40,
                width: 98,
                borderRadius: 4,
                fontWeight: 500,
                fontSize: 16,
                color: '#fff',
                letterSpacing: '0.15px',
                marginBottom: '24px',
              }}
            >
              {$i18n.get({ id: 'aopf.pages.miniapp.version.info.confirm.Ok', dm: '确定' })}
            </FormSubmit>
            <Button 
              className="nextBtn-cancel" 
              onClick={() => setVisible(false)}
              style={{
                height: 40,
                width: 98,
                borderRadius: 4,
                fontWeight: 500,
                fontSize: 16,
                letterSpacing: '0.15px',
                marginBottom: '24px',
              }}
            >
              {$i18n.get({ id: 'aopf.pages.miniapp.version.info.confirm.Cancel', dm: '取消' })}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Confirm;
